import { track } from '@hotjar/webapp/domains/common/tracking/segment';
import { extractSiteGroupingProps } from '@hotjar/webapp/tracking/utils';
import { Site } from '@hotjar/site';

const getUrl = (): string => window.location.pathname + window.location.search;

type RecordingsCount = {
  recordings_relevant_count: number;
  recordings_with_rage_clicks_count: number;
  recordings_engaged_count: number;
  recordings_with_uturns_count: number;
};

export const OVERVIEW_MOST_RELEVANT_RECORDINGS_TITLE = 'Top most relevant';

export enum OverviewTrackingElements {
  MOST_RELEVANT_TILE = 'Most relevant title',
  MOST_RELEVANT_BUTTON = 'Most relevant button',
  WIDGET_HEADING = 'Widget Heading',
  WIDGET_FOOTER = 'Widget Footer',
  WIDGET_ROW = 'Widget Row',
  WIDGET_ROW_PLAY_BUTTON = 'Widget Row Play Button',
  WIDGET_FOOTER_BUTTON = 'Widget Footer Button',
}

export const trackRecordingsOverviewViewed = (
  site: Site,
  userId: number,
  recordingsCount: RecordingsCount,
): void => {
  track('Recordings Overview Viewed', {
    ...extractSiteGroupingProps(site),
    user_id: userId,
    url_event_was_triggered_on: getUrl(),
    ...recordingsCount,
  });
};

export const trackOnOverviewPlayClick = (
  site: Site,
  userId: number,
  widgetInfo: {
    title: string;
    renderPosition: number;
    elementName: string;
  },
): void => {
  track('Element Clicked', {
    url_event_was_triggered_on: getUrl(),
    user_id: userId,
    element_name: widgetInfo.elementName,
    ui_position: `${widgetInfo.title}_${widgetInfo.renderPosition}`,
    state_event_was_triggered_on: 'Overview',
    ...extractSiteGroupingProps(site),
  });
};

export const trackOnOverviewViewAllClick = (
  site: Site,
  userId: number,
  widgetTitle: string,
  elementName: string,
): Promise<void> => {
  return track('Element Clicked', {
    url_event_was_triggered_on: getUrl(),
    user_id: userId,
    element_name: elementName,
    ui_position: `Recordings Overview - ${widgetTitle}`,
    ...extractSiteGroupingProps(site),
  });
};

export const trackToggleClick = (site: Site, userId: number, triggeredOn: string): void => {
  track('Element Clicked', {
    element_name: 'Recordings View Toggle',
    ui_position: 'Recording View',
    url_event_was_triggered_on: getUrl(),
    user_id: userId,
    state_event_was_triggered_on: triggeredOn,
    ...extractSiteGroupingProps(site),
  });
};
